<template>
  <v-container class="error-page fill-height" tag="section">
    <v-row class="text-center" justify="center">
      <v-col cols="auto">
        <h1 class="font-weight-black title">404</h1>

        <div class="display-3 mb-5 mt-10">Página não encontrada :(</div>

        <v-btn depressed @click="redirectHome()">Ir para página inicial!</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'PagesError',

    computed: {
      siglaEmpresa() {
        return this.$store.getters.getSiglaEmpresa;
      }
    },

    methods: {
      redirectHome() {
        if (this.siglaEmpresa === 'LITE') {
          this.$router.replace({ name: 'Power Ups' });
        } else {
          this.$router.replace({ name: 'Home' });
        }
      }
    }
  };
</script>

<style lang="sass">
  .error-page
    h1
      font-size: 12rem
</style>